<template>
  <div class="w-100">
    <SvgGridOverlay v-if="data.isSvg" :data="data" />
    <CommonOverlay v-else :data="data" />
  </div>
</template>

<script>
import CommonOverlay from '@/components/Vectors/CommonOverlay';
import SvgGridOverlay from '@/components/Vectors/SvgGridOverlay';
export default {
  components: {
    CommonOverlay,
    SvgGridOverlay
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};
</script>
